/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Supervisory_UrlInputs */

const en_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const de_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const fr_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const es_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const it_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const nl_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const pl_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const fi_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const da_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

const sv_privacy_supervisory_url = /** @type {(inputs: Privacy_Supervisory_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.lda.bayern.de`)
};

/**
* | output |
* | --- |
* | "https://www.lda.bayern.de" |
*
* @param {Privacy_Supervisory_UrlInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_supervisory_url = /** @type {((inputs?: Privacy_Supervisory_UrlInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Supervisory_UrlInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_supervisory_url(inputs)
	if (locale === "fr") return fr_privacy_supervisory_url(inputs)
	if (locale === "es") return es_privacy_supervisory_url(inputs)
	if (locale === "it") return it_privacy_supervisory_url(inputs)
	if (locale === "nl") return nl_privacy_supervisory_url(inputs)
	if (locale === "pl") return pl_privacy_supervisory_url(inputs)
	if (locale === "fi") return fi_privacy_supervisory_url(inputs)
	if (locale === "da") return da_privacy_supervisory_url(inputs)
	if (locale === "sv") return sv_privacy_supervisory_url(inputs)
	return en_privacy_supervisory_url(inputs)
});